import Vue from 'vue'
// import VueAnimateOnScroll from 'vue-animate-onscroll'
import VueAnimateOnScroll from '~/assets/js/vue-animate-onscroll.js'

Vue.use(VueAnimateOnScroll)